export default class ScrollHelper {
    static scrollTo(target) {
        const element = document.getElementById(target);
        const top = element.offsetTop;

        window.scrollTo({top: top, left: 0, behavior: 'smooth'});
    }
}